import React from "react";
import { UserStore } from "./UserStore";
import { WorkflowStore } from "./WorkflowStore";
import { ClaimStore } from "./ClaimStore";


export interface IStore {
    userStore: UserStore;
    workflowStore: WorkflowStore;
    claimStore: ClaimStore;
}

const userStore = new UserStore();

export const store: IStore = {
    userStore : new UserStore(),
    workflowStore : new WorkflowStore(),
    claimStore: new ClaimStore(userStore)
};

export const StoreContext = React.createContext(store);
export const useStores = () => React.useContext(StoreContext);
